import { FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { backendUrl } from 'utils/constants/url';
import { getTokenFromLocalStorage, getTokenTypeFromLocalStorage } from 'utils/functions/getToken';
import { TAuthResponse } from './types/AuthTypes';

export const baseQuery = fetchBaseQuery({
  baseUrl: backendUrl,
  prepareHeaders(headers) {
    headers.set('Authorization', `${getTokenTypeFromLocalStorage()} ${getTokenFromLocalStorage()}`);
  },
});

const tokenBaseQuery = fetchBaseQuery({
  baseUrl: backendUrl,
});

type RefreshData = {
  data?: TAuthResponse;
};

export const getBaseQueryWithReauth = (
  baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>,
): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> => {
  return async function (args, api, extraOptions) {
    let result = await baseQuery(args, api, extraOptions);

    if (
      result.error &&
      (result.error.status === 401 ||
        result.error.status === 403 ||
        result.error.data === 'Unauthorized')
    ) {
      const token = (await tokenBaseQuery(
        {
          url: 'auth/token/refresh/',
          method: 'POST',
          body: { refresh_token: localStorage.getItem('refresh_token') || '' },
        },
        api,
        extraOptions,
      )) as RefreshData;

      if (token.data?.access_token && token.data.refresh_token && token.data.token_type) {
        localStorage.setItem('token', token.data.access_token);
        localStorage.setItem('token_type', token.data.token_type);
        localStorage.setItem('refresh_token', token.data.refresh_token);
        result = await baseQuery(args, api, extraOptions);
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('token_type');
        localStorage.removeItem('refresh_token');
        window.location.href = '/';
      }
    }
    return result;
  };
};
